import { applySelectedFormatToElement } from '@/utils/tinyMCE/updateDynamicText/applySelectedFormatToElement'
import { removeSelectedFormatFromElement } from '@/utils/tinyMCE/updateDynamicText/removeSelectedFormatFromElement'
import { TINYMCE_FONT_CHANGE_EVENT } from '@/utils/tinyMCE/fontChangeEvent'
import { pinSelectedBlockFonts } from '@/utils/tinyMCE/pinEditorBlockFonts'

const approvedCommands = [
  'fontsize',
  'lineheight',
  'fontname',
  'mceinserttemplate',
  'mceRemoveTextcolor',
]

export const commandHandler = ({
  editor,
  updateHeight,
  onCaseDetailTemplateInserted,
}) => {
  if (!updateHeight) return

  // Fires for the initial content and for every programmatic reset (a
  // re-applied dynamic text, a fitted text) as well as for an insert at the
  // caret. The box holds every height write until its load result has
  // painted; the origin is what its probe mark records.
  editor.on('SetContent', () => {
    updateHeight('content')
  })

  editor.on('BeforeExecCommand', (e) => {
    const commandIsAbsent = !e || !e.command
    if (commandIsAbsent) return

    const command = e.command

    switch (command) {
      case 'mceRemoveTextcolor': {
        const nameOfDeceased = '[data-case-detail="name_of_deceased"]'
        const propertyName = 'background-color'
        const selectedNode = editor?.selection?.getNode?.()
        const isWithinNameOfDeceased = selectedNode?.closest?.(nameOfDeceased)

        if (isWithinNameOfDeceased) {
          e.preventDefault()
          removeSelectedFormatFromElement(editor, nameOfDeceased, propertyName)
        }
        break
      }
      default:
        break
    }
  })

  editor.on('ExecCommand', (e) => {
    const commandIsAbsent = !e || !e.command
    if (commandIsAbsent) return

    const command = e.command.toLowerCase()

    const isApprovedCommand = approvedCommands.includes(command)
    if (!isApprovedCommand) return

    switch (command) {
      case 'mceinserttemplate':
        onCaseDetailTemplateInserted?.(Date.now())
        break
      case 'fontsize':
        applySelectedFormatToElement(
          editor,
          '[data-case-detail="obituary"]',
          'FontSize',
          'font-size',
        )
        pinSelectedBlockFonts(editor)
        break
      case 'fontname':
        applySelectedFormatToElement(
          editor,
          '[data-case-detail="obituary"]',
          'FontName',
          'font-family',
        )
        pinSelectedBlockFonts(editor)
        // Let useLayoutUsedFonts fold the just-applied font into the
        // "Used in this layout" dropdown section without re-scanning pages.
        window.dispatchEvent(
          new CustomEvent(TINYMCE_FONT_CHANGE_EVENT, {
            detail: { fontName: e.value },
          }),
        )
        break
    }

    updateHeight('edit')
  })
}
